import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import threat from './threat';
import controller from './perform-threat-assessment-dialog.controller';
import template from './perform-threat-assessment-dialog.html';


class dialogService {
  getOptions($event, { assessmentId, threatOptions, assessmentThreats }) {
    return {
      controller,
      controllerAs: 'performThreatAssessmentDialogVM',
      locals: {
        assessmentId,
        threatOptions,
        assessmentThreats
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.performThreatAssessmentDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
  threat,
])
  .service('performThreatAssessmentDialog', dialogService)
  .name;
